import { Component, EventEmitter , Input , Output,OnInit } from '@angular/core';
import {ViewCell} from '../../ng2-smart-table/components/cell/cell-view-mode/view-cell';


@Component({
  selector: 'app-table-manage-connection',
  template: `<a href="javascript:;"class="status-link text-link" (click) = "onLinkClick()">Manage connection</a>` ,
  styleUrls: ['./table-manage-connection.component.scss']
})
export class TableManageConnectionComponent implements ViewCell , OnInit {

  @Input() value : string | number;
  @Input() rowData : any;

  @Output() outdata : EventEmitter<any> = new EventEmitter();

  ngOnInit() {

  }
  onLinkClick(){
  	this.outdata.emit(this.rowData);
  	return false;
  }

}
